// @ts-nocheck
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setAddToListModalIsOpen from "@insite/client-framework/Store/Components/AddToListModal/Handlers/SetAddToListModalIsOpen";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import addToWishList from "@insite/client-framework/Store/Data/WishLists/Handlers/AddToWishList";
import translate from "@insite/client-framework/Translate";
import { OrderLineModel, OrderModel, ProductPriceDto } from "@insite/client-framework/Types/ApiModels";
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import ProductDescription, { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Tooltip, { TooltipPresentationProps } from "@insite/mobius/Tooltip";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Block, { BlockProps } from "@store/Library/Components/Toolkit/Block";
import AlertCircle from "@store/Library/Components/Toolkit/Icons/AlertCircle/AlertCircleLine";
import ProductImage, { ProductImageStyles } from "@store/Overrides/Components/ProductImage";
import { orderProps } from "@store/Themes/common/props/order";
import ReviewOrderChangeRequestAddedLine from "@store/Library/Components/ReviewOrderChangeRequest/ReviewOrderChangeRequestAddedLine";
import Status from "@store/Library/Components/Status";
import {
    ChangeRequestLineModel,
    ChangeRequestModel,
} from "@store/Library/Widgets/RequestOrderChange/RequestOrderChangePageContainer";
import ProductPartNumbers, { ProductPartNumbersStyles } from "@store/Overrides/Components/ProductPartNumbers";
import SmallHeadingAndText, { SmallHeadingAndTextStyles } from "@store/Overrides/Components/SmallHeadingAndText";
import { attributeSpacing, attributesProps } from "@store/Themes/common/props/attributes";
import { orderChangeProps } from "@store/Themes/common/props/orderChange";
import { productLineProps } from "@store/Themes/common/props/productLine";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import useMergeProps from "@toolkit/Framework/Common/Hooks/useMergeProps";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { gridGapStyles, spacingStyles } from "@toolkit/Themes/common/mixins";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const StyledSpan = getStyledWrapper("span");

interface OwnProps {
    order?: OrderModel;
    extendedStyles?: ReviewChangeRequestLinesListStyles;
    showLineNumber?: boolean;
}

const mapStateToProps = (state: ApplicationState) => ({
    wishListSettings: getSettingsCollection(state).wishListSettings,
    enableVat: getSettingsCollection(state).productSettings.enableVat,
    vatPriceDisplay: getSettingsCollection(state).productSettings.vatPriceDisplay,
    changeRequestOrder: state.greif.pages.orderChange.changeRequestOrder,
});

const mapDispatchToProps = {
    setAddToListModalIsOpen,
    addToWishList,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface ReviewOrderChangeRequestLineNotesStyles {
    typographyStyles?: TypographyProps;
    gridItemStyles?: GridItemProps;
    wrapper?: InjectableCss;
}
export interface UpdatedLineStyle {
    wrapper?: InjectableCss;
    oldValue?: TypographyProps;
    newValue?: TypographyProps;
    newValueCanceled?: TypographyProps;
}

export interface ReviewChangeRequestLinesListStyles {
    orderLineCartWrapper?: InjectableCss;
    orderLineCardGridContainer?: GridContainerProps;
    orderLineCardImageGridItem?: GridItemProps;
    orderLineCardInfoGridItem?: GridItemProps;
    orderLineCardInfoGridContainer?: GridContainerProps;
    productBrandStyles?: ProductBrandStyles;
    productInfoSectionOptionsGridItem?: GridItemProps;
    productInfoPartNumbersGridItem?: GridItemProps;
    productInfoSectionOptionsText?: InjectableCss;
    productInfoGridItem?: GridItemProps;
    productInfoBrandDescriptionGridItem?: GridItemProps;
    productDescriptionStyles?: ProductDescriptionStyles;
    orderLineInfoPromotionGridItem?: GridItemProps;
    orderLineInfoPromotionText?: TypographyProps;
    orderLineInfoGridItem?: GridItemProps;
    orderLineInfoGridContainer?: GridContainerProps;
    orderLinePriceGridItem?: GridItemProps;
    vatLabelText?: TypographyPresentationProps;
    secondaryVatLabelText?: TypographyPresentationProps;
    productInfoQtyOrderedGridItem?: GridItemProps;
    productInfoQtyOrderedHeadingAndText?: SmallHeadingAndTextStyles;
    productInfoQtyShippedGridItem?: GridItemProps;
    productInfoQtyShippedHeadingAndText?: SmallHeadingAndTextStyles;
    subtotalWithoutVatHeadingAndText?: SmallHeadingAndTextStyles;
    block?: BlockProps;
    productImage?: ProductImageStyles;
    orderLineInfoContainer?: GridContainerProps;
    productPartNumbers?: ProductPartNumbersStyles;
    productInfoVmiBinNumberWrapper?: InjectableCss;
    vmiBinNumberLabel?: TypographyProps;
    vmiBinNumberValue?: TypographyProps;
    subtotalWithoutVatText?: TypographyPresentationProps;
    priceLabel?: TypographyPresentationProps;
    priceWrapper?: InjectableCss;
    priceUnitOfMeasure?: TypographyPresentationProps;
    priceSecondaryWrapper?: InjectableCss;
    ftlWrapper?: InjectableCss;
    leadTimeWrapper?: InjectableCss;
    shipFromLabel?: TypographyPresentationProps;
    shipFromText?: TypographyPresentationProps;
    leadTimeText?: TypographyPresentationProps;
    leadTimeTooltip?: TooltipPresentationProps;
    infoWrapper?: InjectableCss;
    pipeText?: TypographyPresentationProps;
    changeRequestGridContainer?: GridContainerProps;
    canceledLineOverlayItem?: GridItemProps;
    canceledTag?: InjectableCss;
    changeInfoHeadingAndText?: SmallHeadingAndTextStyles;
    changeRequestReasonGridItem?: GridItemProps;
    changeRequestNotesGridItem?: GridItemProps;
    changeRequestQtyGridItem?: GridItemProps;
    productCountWrapper?: InjectableCss;
    productCountText?: TypographyPresentationProps;
    productCanceledCountText?: TypographyPresentationProps;
    productAddedCountText?: TypographyPresentationProps;
    productAdditionalInfos?: GridItemProps;
}

export const reviewChangeRequestLinesListStyles: ReviewChangeRequestLinesListStyles = {
    block: orderChangeProps.block,
    orderLineCartWrapper: orderChangeProps.orderLineCartWrapper,
    orderLineCardGridContainer: orderChangeProps.orderLineCardGridContainer,
    orderLineCardImageGridItem: productLineProps.imageGridItem,
    productImage: productLineProps.image,
    orderLineCardInfoGridItem: productLineProps.contentGridItem,
    orderLineCardInfoGridContainer: productLineProps.contentContainer,
    productInfoGridItem: productLineProps.infoGridItem,
    orderLineInfoContainer: productLineProps.contentContainer,
    productInfoBrandDescriptionGridItem: productLineProps.descriptionGridItem,
    productBrandStyles: productLineProps.brand,
    productDescriptionStyles: productLineProps.description,
    productInfoPartNumbersGridItem: productLineProps.partNumbersGridItem,
    productPartNumbers: productLineProps.partNumbers,
    productInfoVmiBinNumberWrapper: mergeProps<ReviewChangeRequestLinesListStyles["productInfoVmiBinNumberWrapper"]>(
        attributesProps.container,
        {
            css: css`
                margin-top: ${attributeSpacing};
            `,
        },
    ),
    vmiBinNumberLabel: attributesProps.label,
    vmiBinNumberValue: attributesProps.value,
    productInfoSectionOptionsGridItem: productLineProps.configurationGridItem,
    productInfoSectionOptionsText: productLineProps.configuration,
    orderLineInfoGridItem: productLineProps.pricingGridItem,
    orderLineInfoGridContainer: productLineProps.contentContainer,
    orderLinePriceGridItem: {
        ...productLineProps.priceGridItem,
        width: [6, 4, 6, 4, 4],
    },
    priceLabel: productLineProps.savedPrice?.label,
    priceWrapper: productLineProps.savedPrice?.wrapper,
    priceSecondaryWrapper: productLineProps.savedPrice?.secondaryWrapper,
    priceUnitOfMeasure: productLineProps.savedPrice?.unitOfMeasure,
    vatLabelText: productLineProps.subtotalVatLabel,
    secondaryVatLabelText: productLineProps.subtotalVatLabel,
    productInfoQtyOrderedGridItem: {
        width: [6, 4, 6, 4, 4],
        css: css`
            display: block;
            align-items: flex-end;
        `,
    },
    productInfoQtyShippedGridItem: {
        width: [6, 4, 6, 4, 4],
    },
    subtotalWithoutVatHeadingAndText: {
        text: {
            ...productLineProps.subtotalValue,
        },
    },
    subtotalWithoutVatText: productLineProps.subtotalSecondValue,
    orderLineInfoPromotionGridItem: { width: 12 },
    orderLineInfoPromotionText: productLineProps.promotion,
    ftlWrapper: orderChangeProps.ftlWrapper,
    shipFromLabel: orderChangeProps.shipFromLabel,
    leadTimeText: orderChangeProps.leadTimeText,
    leadTimeTooltip: orderChangeProps.leadTimeTooltip,
    infoWrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 80%;
        `,
    },
    leadTimeWrapper: orderChangeProps.leadTimeWrapper,
    pipeText: {
        size: 18,
        css: css`
            padding: 0 ${pxToRem(9)};
        `,
    },
    changeRequestGridContainer: orderChangeProps.ocrGridContainer,
    canceledLineOverlayItem: orderChangeProps.canceledLineOverlayItem,
    canceledTag: orderChangeProps.canceledTag,
    changeInfoHeadingAndText: orderChangeProps.changeInfoHeadingAndText,
    changeRequestReasonGridItem: orderChangeProps.reasonGridItem,
    changeRequestNotesGridItem: orderChangeProps.notesGridItem,
    changeRequestQtyGridItem: orderChangeProps.qtyGridItem,
    productCountWrapper: {
        css: css`
            display: flex;
            gap: ${pxToRem(8)};
        `,
    },
    productCountText: orderProps.subtitle,
    productCanceledCountText: {
        ...orderProps.subtitle,
        color: "danger",
    },
    productAddedCountText: {
        ...orderProps.subtitle,
        color: "success",
    },
    productAdditionalInfos: {
        width: 12,
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
};

const ReviewOrderChangeRequestLineProductInfo = ({
    orderLine,
    styles,
    showLineNumber,
    currentLine,
}: {
    orderLine: OrderLineModel;
    styles: ReviewChangeRequestLinesListStyles;
    showLineNumber: boolean;
    currentLine: ChangeRequestLineModel;
}) => {
    const sectionOptions = (orderLine.sectionOptions && orderLine.sectionOptions) || [];
    return (
        <GridItem {...styles.productInfoGridItem}>
            <GridContainer {...styles.orderLineInfoContainer}>
                <GridItem {...styles.productInfoBrandDescriptionGridItem}>
                    {orderLine.brand && (
                        <ProductBrand brand={orderLine.brand} extendedStyles={styles.productBrandStyles} />
                    )}
                    <ProductDescription product={orderLine} extendedStyles={styles.productDescriptionStyles} />
                </GridItem>
                <GridItem {...styles.productInfoPartNumbersGridItem}>
                    <ProductPartNumbers
                        productNumber={orderLine.productErpNumber}
                        customerProductNumber={orderLine.customerProductNumber}
                        manufacturerItem={orderLine.manufacturerItem}
                        extendedStyles={styles.productPartNumbers}
                        showLineNumber={showLineNumber}
                        cartLineNumber={orderLine.lineNumber}
                    />
                    {orderLine.vmiBinNumber && (
                        <StyledSpan {...styles.productInfoVmiBinNumberWrapper}>
                            <Typography {...styles.vmiBinNumberLabel}>
                                {translate("Bin #")}
                                {translate(":")}
                            </Typography>
                            <Typography {...styles.vmiBinNumberValue}>{orderLine.vmiBinNumber}</Typography>
                        </StyledSpan>
                    )}
                </GridItem>
                {orderLine.productId && (
                    <GridItem {...styles.productAdditionalInfos}>
                        <StyledWrapper {...styles.infoWrapper}>
                            <StyledWrapper {...styles.ftlWrapper}>
                                {orderLine.properties.fullTruckLoad && (
                                    <>
                                        <Typography {...styles.shipFromLabel}>
                                            {translate("Full Truck Load")}
                                            {translate(":")}
                                        </Typography>
                                        <Typography {...styles.shipFromText}>{` ${
                                            orderLine.properties.fullTruckLoad || translate("N/A")
                                        }`}</Typography>
                                        <Typography {...styles.pipeText}> | </Typography>
                                    </>
                                )}
                            </StyledWrapper>
                            {orderLine.properties.leadTime && (
                                <StyledWrapper {...styles.leadTimeWrapper}>
                                    <Status showIcon type="green">
                                        <Typography {...styles.leadTimeText}>
                                            {Number(orderLine.properties.leadTime) === 1
                                                ? translate(
                                                      "Lead Time {0} week.",
                                                      String(orderLine.properties.leadTime),
                                                  )
                                                : translate(
                                                      "Lead Time {0} weeks.",
                                                      String(orderLine.properties.leadTime),
                                                  )}
                                        </Typography>
                                        <Tooltip
                                            {...styles.leadTimeTooltip}
                                            text={siteMessage("Product_LeadTimeTooltipRegularProduct") as string}
                                        />
                                    </Status>
                                </StyledWrapper>
                            )}
                        </StyledWrapper>
                    </GridItem>
                )}
                {sectionOptions.length > 0 && (
                    <GridItem {...styles.productInfoSectionOptionsGridItem}>
                        {sectionOptions.map(option => (
                            <Typography
                                {...styles.productInfoSectionOptionsText}
                                key={option.sectionOptionId.toString()}
                            >
                                {option.sectionName}: {option.optionName}
                            </Typography>
                        ))}
                    </GridItem>
                )}
            </GridContainer>
        </GridItem>
    );
};

const mapStateToReviewOrderChangeRequestLineInfoProps = (state: ApplicationState) => ({
    enableVat: getSettingsCollection(state).productSettings.enableVat,
    vatPriceDisplay: getSettingsCollection(state).productSettings.vatPriceDisplay,
});

const ReviewOrderChangeRequestLineInfoProto = ({
    orderLine,
    order,
    enableVat,
    vatPriceDisplay,
    styles,
    currentLine,
}: {
    orderLine: OrderLineModel;
    order: OrderModel;
    enableVat: boolean;
    vatPriceDisplay: string;
    styles: ReviewChangeRequestLinesListStyles;
    currentLine: ChangeRequestLineModel;
}) => {
    const promotions =
        (order.orderPromotions &&
            order.orderPromotions.filter(promotion => promotion.orderHistoryLineId === orderLine.id)) ||
        [];

    return (
        <GridItem {...styles.orderLineInfoGridItem}>
            <GridContainer {...styles.orderLineInfoGridContainer}>
                <GridItem width={12}>
                    <GridContainer {...styles.orderLineInfoGridContainer}>
                        <GridItem {...styles.orderLinePriceGridItem}>
                            <SmallHeadingAndText
                                extendedStyles={styles.productInfoQtyOrderedHeadingAndText}
                                heading={translate("QTY Ordered")}
                                data-test-selector="qty_Ordered"
                                text={currentLine.isCanceled ? "0" : orderLine.qtyOrdered}
                            />
                        </GridItem>
                        <GridItem {...styles.productInfoQtyOrderedGridItem}>
                            <Typography {...styles.priceLabel}>{translate("Price")}</Typography>
                            <StyledWrapper {...styles.priceWrapper}>
                                {currentLine.isCanceled ? "0" : orderLine.unitPriceDisplay}
                            </StyledWrapper>
                            {enableVat && (
                                <>
                                    <Typography {...styles.vatLabelText}>
                                        {vatPriceDisplay === "DisplayWithVat" ||
                                        vatPriceDisplay === "DisplayWithAndWithoutVat"
                                            ? `${translate("Inc. VAT")} (${orderLine.taxRate}%)`
                                            : translate("Ex. VAT")}
                                    </Typography>
                                    {vatPriceDisplay === "DisplayWithAndWithoutVat" && (
                                        <>
                                            <StyledWrapper {...styles.priceSecondaryWrapper}>
                                                {orderLine.unitPriceDisplay}
                                                {orderLine.unitOfMeasure ? (
                                                    <Typography {...styles.priceUnitOfMeasure}>
                                                        &nbsp;/&nbsp;{orderLine.unitOfMeasure}
                                                    </Typography>
                                                ) : null}
                                            </StyledWrapper>
                                            <Typography {...styles.secondaryVatLabelText}>
                                                {translate("Ex. VAT")}
                                            </Typography>
                                        </>
                                    )}
                                </>
                            )}
                        </GridItem>
                        <GridItem {...styles.productInfoQtyShippedGridItem}>
                            <SmallHeadingAndText
                                extendedStyles={styles.subtotalWithoutVatHeadingAndText}
                                heading={translate("Subtotal")}
                                text={currentLine.isCanceled ? "0" : orderLine.properties.totalNetPriceDisplay}
                            />
                            {enableVat && (
                                <>
                                    <Typography {...styles.vatLabelText}>
                                        {vatPriceDisplay === "DisplayWithVat" ||
                                        vatPriceDisplay === "DisplayWithAndWithoutVat"
                                            ? `${translate("Inc. VAT")} (${orderLine.taxRate}%)`
                                            : translate("Ex. VAT")}
                                    </Typography>
                                    {vatPriceDisplay === "DisplayWithAndWithoutVat" && (
                                        <>
                                            <Typography {...styles.subtotalWithoutVatText}>
                                                {orderLine.extendedUnitNetPriceDisplay}
                                            </Typography>
                                            <Typography {...styles.vatLabelText}>{translate("Ex. VAT")}</Typography>
                                        </>
                                    )}
                                </>
                            )}
                        </GridItem>
                    </GridContainer>
                </GridItem>
                <GridItem width={12}>
                    <GridContainer {...styles.orderLineInfoGridContainer}>
                        <GridItem {...styles.orderLinePriceGridItem}>
                            <SmallHeadingAndText
                                extendedStyles={styles.productInfoQtyShippedHeadingAndText}
                                heading={translate("QTY Shipped")}
                                text={currentLine.isCanceled ? "0" : orderLine.qtyShipped}
                            />
                        </GridItem>
                        <GridItem {...styles.orderLinePriceGridItem}>
                            <SmallHeadingAndText
                                extendedStyles={styles.productInfoQtyShippedHeadingAndText}
                                heading={translate("QTY Remaining")}
                                text={currentLine.isCanceled ? "0" : orderLine.properties.qtyRemaining}
                            />
                        </GridItem>
                        <GridItem {...styles.orderLinePriceGridItem}>
                            <SmallHeadingAndText
                                extendedStyles={styles.subtotalWithoutVatHeadingAndText}
                                heading={translate("Delivered Amount")}
                                text={currentLine.isCanceled ? "0" : orderLine.properties.totalDeliveryAmountDisplay}
                            />
                        </GridItem>
                    </GridContainer>
                </GridItem>
                {promotions.length > 0 && (
                    <GridItem {...styles.orderLineInfoPromotionGridItem}>
                        <Typography {...styles.orderLineInfoPromotionText}>
                            {translate("Promotions")}
                            {translate(":")} {promotions.map(x => x.name).join(", ")}
                        </Typography>
                    </GridItem>
                )}
            </GridContainer>
        </GridItem>
    );
};

const ReviewOrderChangeRequestLineInfo = connect(mapStateToReviewOrderChangeRequestLineInfoProps)(
    ReviewOrderChangeRequestLineInfoProto,
);

const ReviewOrderChangeRequestLineCard = (props: {
    orderLine: OrderLineModel;
    order: OrderModel;
    styles: ReviewChangeRequestLinesListStyles;
    showLineNumber: boolean;
    changeRequestOrder: ChangeRequestModel;
}) => {
    const { orderLine, order, styles, showLineNumber, changeRequestOrder } = props;
    const [currentLine, setCurrentLine] = useState<ChangeRequestLineModel>({} as ChangeRequestLineModel);

    useEffect(() => {
        if (changeRequestOrder && changeRequestOrder.orderLines) {
            const line = changeRequestOrder.orderLines.find(l => l.orderLineId === orderLine.id);
            if (line) {
                setCurrentLine(line);
            }
        }
    }, [changeRequestOrder]);

    const orderLineCartWrapperStyles: InjectableCss = mergeProps(styles.orderLineCartWrapper, {
        css: css`
            border-color: ${getColor(`${currentLine?.isCanceled ? "danger" : "common.border"}`)};
        `,
    });

    return (
        <StyledWrapper {...orderLineCartWrapperStyles}>
            <GridContainer
                {...styles.orderLineCardGridContainer}
                data-test-selector={`orderLineCard${orderLine.productId}`}
            >
                {currentLine?.isCanceled && (
                    <GridItem {...styles.canceledLineOverlayItem}>
                        <StyledWrapper {...styles.canceledTag}>
                            <Typography>{translate("Canceled")}</Typography>
                        </StyledWrapper>
                    </GridItem>
                )}
                <GridItem {...styles.orderLineCardImageGridItem}>
                    <ProductImage product={orderLine as any} size="medium" extendedStyles={styles.productImage} />
                </GridItem>
                <GridItem {...styles.orderLineCardInfoGridItem}>
                    <GridContainer {...styles.orderLineCardInfoGridContainer}>
                        <ReviewOrderChangeRequestLineProductInfo
                            orderLine={orderLine}
                            styles={styles}
                            showLineNumber={showLineNumber}
                            currentLine={currentLine}
                        />
                        <ReviewOrderChangeRequestLineInfo
                            orderLine={orderLine}
                            order={order}
                            styles={styles}
                            currentLine={currentLine}
                        />
                    </GridContainer>
                </GridItem>
            </GridContainer>
            {!orderLine.productId ? (
                <GridContainer {...styles.changeRequestGridContainer}>
                    <GridItem width={12}>
                        <Typography>{siteMessage("ReviewOrderChange_ProductNoLongerAvailable")}</Typography>
                    </GridItem>
                </GridContainer>
            ) : (
                <GridContainer {...styles.changeRequestGridContainer}>
                    <GridItem {...styles.changeRequestReasonGridItem}>
                        <SmallHeadingAndText
                            extendedStyles={styles.changeInfoHeadingAndText}
                            heading={translate("Change Request Reason")}
                            text={currentLine.changeReason || translate("N/A")}
                        />
                    </GridItem>
                    <GridItem {...styles.changeRequestNotesGridItem}>
                        <SmallHeadingAndText
                            extendedStyles={styles.changeInfoHeadingAndText}
                            heading={translate("Change Request Note")}
                            text={currentLine.changeNotes || translate("N/A")}
                        />
                    </GridItem>
                    <GridItem {...styles.changeRequestQtyGridItem}>
                        <SmallHeadingAndText
                            extendedStyles={styles.changeInfoHeadingAndText}
                            heading={translate("New QTY")}
                            text={currentLine.isCanceled ? "0" : currentLine.newQuantity}
                        />
                    </GridItem>
                </GridContainer>
            )}
        </StyledWrapper>
    );
};

const ReviewChangeRequestLinesList = ({ order, extendedStyles, showLineNumber, changeRequestOrder }: Props) => {
    const styles = useMergeProps(reviewChangeRequestLinesListStyles, extendedStyles);
    const [canTrackViewItemList, setCanTrackViewItemList] = useState(true);
    const trackViewItemList = ga.use.trackViewItemList({}, { order });

    if (!order || !order.orderLines) {
        return null;
    }

    const [hasCanceledProducts, setHasCanceledProducts] = useState<boolean>(false);
    const [cancelProductsCount, setCancelProductsCount] = useState<number>(0);

    if (canTrackViewItemList) {
        trackViewItemList();
        setCanTrackViewItemList(false);
    }

    useEffect(() => {
        if (changeRequestOrder && changeRequestOrder.orderLines) {
            setHasCanceledProducts(changeRequestOrder.orderLines.some(l => l.isCanceled));
            setCancelProductsCount(changeRequestOrder.orderLines.filter(l => l.isCanceled).length);
        }
    }, [changeRequestOrder]);

    const productsLabel = order.orderLines.length === 1 ? translate("Item") : translate("Items");

    return (
        <Block {...styles.block}>
            <StyledWrapper {...styles.productCountWrapper}>
                <Typography {...styles.productCountText}>{`${
                    order.orderLines.length + (changeRequestOrder?.newLines?.length || 0)
                } ${productsLabel}`}</Typography>
                {hasCanceledProducts && <Typography {...styles.pipeText}> | </Typography>}
                {hasCanceledProducts && (
                    <Typography {...styles.productCanceledCountText}>{`${cancelProductsCount} ${translate(
                        "Canceled",
                    )}`}</Typography>
                )}
                {changeRequestOrder?.newLines?.length !== 0 && changeRequestOrder?.newLines && (
                    <Typography {...styles.pipeText}> | </Typography>
                )}
                {changeRequestOrder?.newLines?.length !== 0 && changeRequestOrder?.newLines && (
                    <Typography {...styles.productAddedCountText}>{`${changeRequestOrder?.newLines?.length} ${translate(
                        "Added",
                    )}`}</Typography>
                )}
            </StyledWrapper>
            <StyledWrapper>
                <ReviewOrderChangeRequestAddedLine order={order} showLineNumber={false} />
                {order.orderLines.map(orderLine => (
                    <ReviewOrderChangeRequestLineCard
                        orderLine={orderLine}
                        order={order}
                        styles={styles}
                        key={orderLine.id + 1}
                        showLineNumber={showLineNumber!}
                        changeRequestOrder={changeRequestOrder}
                    />
                ))}
            </StyledWrapper>
        </Block>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(ReviewChangeRequestLinesList);
